var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIsdoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 85 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "SI_4L_stroke",
    d: "M29.6 4.7h15.8l10.2 9.1v23.9h-26z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "SI_4L_stroke",
    d: "M45.3 5.2v9h9.9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "SI_4L_fill_green",
    d: "M45.6 28.8c3-3 5.3-8.6 4.1-9.7-1-1-5.8.4-9.6 4.1-3.9 3.9-5.1 8.8-4.2 9.6.8.9 6.2-.6 9.7-4zM36.8 24.6c-1.3-2.5-1.6-4.7-.9-5.3.7-.7 2.9-.2 5.2.9-1.1.6-3 2.1-4.3 4.4zM48.8 27.4c1.3 2.5 1.6 4.7.9 5.3-.7.7-2.9.2-5.2-.9 1.1-.7 3-2.1 4.3-4.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsdoc);
export default __webpack_public_path__ + "static/media/isdoc.8381a3d42d646c12a6318d41aa09056a.svg";
export { ForwardRef as ReactComponent };